import React, { useEffect, useState, useRef } from 'react';
import { Link, useParams } from "react-router-dom";
import Alert from 'react-bootstrap/Alert';
import Header from '../../includes/Header';
import { Container, Row, Col } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import { useFormik } from 'formik';
import { FaChevronUp } from "react-icons/fa";
import { postUpdateCaseType, getProfile, postIncidentViewDetail, getDepartmentList, getCategoriesList, getAircarftType, getAirLineOperators, getAirportMaster, getAircraftRegistrationMaster } from '../../apiservices/ApiServices';
import Loader from '../../components/Loader/Loader';
import 'dayjs/locale/en';
import { $ } from 'react-jquery-plugin';

import AircraftRelated from '../Forms/WhatOccurred/AviationSafety/AircraftRelated/AircraftRelated';
import VehicleRelated from '../Forms/WhatOccurred/AviationSafety/VehicleRelated/VehicleRelated';
import HealthRelated from '../Forms/WhatOccurred/AviationSafety/HealthRelated/HealthRelated';
import AepResponse from '../Forms/WhatOccurred/AviationSafety/AepResponse/AepResponse';
import JetBlastRelated from '../Forms/WhatOccurred/AviationSafety/JetBlastRelated/JetBlastRelated';
import FireExplosionRelated from '../Forms/WhatOccurred/AviationSafety/FireExplosionRelated/FireExplosionRelated';
import RunwayRelated from '../Forms/WhatOccurred/AviationSafety/RunwayRelated/RunwayRelated';
import BuildingInfrastructureRelated from '../Forms/WhatOccurred/AviationSafety/BuildingInfrastructureRelated/BuildingInfrastructureRelated';

import PassengerTerminalIncident from '../Forms/WhatOccurred/Hsse/PassengerTerminalIncident/PassengerTerminalIncident';
import CarParkCurbsideIncident from '../Forms/WhatOccurred/Hsse/CarParkCurbsideIncident/CarParkCurbsideIncident';
import BuildingEnvironmental from '../Forms/WhatOccurred/Hsse/BuildingEnvironmental/BuildingEnvironmental';
import HSSEOthers from '../Forms/WhatOccurred/Hsse/HSSEOthers/HSSEOthers';

import DescriptionFrm from '../Forms/DescriptionFrm/DescriptionFrm';
import WhyDidItHappen from '../Forms/WhyDidItHappen/WhyDidItHappen';
import WhoWasInvolvedForms from '../Forms/WhoWasInvolvedForms/WhoWasInvolvedForms';
import StatementForms from '../Forms/StatementForms/StatementForms';
import ActionTakenByDepartment from '../Forms/ActionTakenByDepartment/ActionTakenByDepartment';
import RiskMatrix from '../Forms/RiskMatrix/RiskMatrix';
import RecommendationActionPlan from '../Forms/RecommendationActionPlan/RecommendationActionPlan';
import PreventingActionPlan from '../Forms/PreventingActionPlan/PreventingActionPlan';
import VerificationMonitoring from '../Forms/VerificationMonitoring/VerificationMonitoring';

import maps from '../../assets/images/map.png';

const Case = () => {
    const [isLoading, setLoading] = useState(true);
    const [isLoadings, setLoadings] = useState(false);
    const [data, setData] = useState([]);
    const [details, setDetails] = useState([]);
    const [department, setDepartment] = useState([]);
    const [categoriesList, setCategoriesList] = useState([]);
    const [selectedCheckboxes, setSelectedCheckboxes] = useState({});
    const [selectedChkParent, setselectedChkParent] = useState({});
    const [aircraftTypes, setAircraftTypes] = useState([]);
    const [airlineOperators, setAirlineOperators] = useState([]);
    const [airport, setAirportList] = useState([]);
    const [aircraftRegistration, setAircraftRegistration] = useState([]);
    const { id } = useParams();
    const [isError, setisError] = useState(false);
    const [msg, setMsg] = useState(false);

    const [pendingValue, setPendingValue] = useState(null);
    const [isShow, setShow] = useState(false);



    useEffect(() => {
        $(document).on('click', '.toggle-button', function () {
            $(this).parent().toggleClass('opens');
        });
        return () => {
            $(document).off('click', '.toggle-button');
        };
    }, []);

    const getAircarftTypes = async () => {
        try {
            const res = await getAircarftType();
            setAircraftTypes(res.data.data);
        } catch (error) {
            console.log(error?.response?.data?.data);
        }
    };

    const getAirLineOperator = async () => {
        try {
            const res = await getAirLineOperators();
            setAirlineOperators(res.data.data);
        } catch (error) {
            console.log(error?.response?.data?.data);
        }
    };

    const getAirportMasters = async () => {
        try {
            const res = await getAirportMaster();
            setAirportList(res.data.data);
        } catch (error) {
            console.log(error?.response?.data?.data);
        }
    };

    const getAircraftRegistrationMasters = async () => {
        try {
            const res = await getAircraftRegistrationMaster();
            setAircraftRegistration(res.data.data);
        } catch (error) {
            console.log(error?.response?.data?.data);
        }
    };

    const getDepartmentLists = async () => {
        try {
            const res = await getDepartmentList();
            setDepartment(res.data.data);
        } catch (error) {
        }
    };

    const getProfiles = async () => {
        setLoading(true);
        try {
            const res = await getProfile();
            setData(res.data.data);
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    };

    const getCategoriesLists = async () => {
        setLoading(true);
        try {
            const res = await getCategoriesList();
            setCategoriesList(res.data.data);
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    };

    const postIncidentViewDetails = async (formData) => {
        setisError(false);
        setMsg('');
        try {
            setLoading(true);
            const res = await postIncidentViewDetail(formData);
            setDetails(res.data.data);
            setLoading(false);
        } catch (error) {
            setisError(true);
            setMsg(error?.response?.data?.errors);
            toast.error(error?.response?.data?.errors);
            console.log(error?.response?.data);
            setLoading(false);
        }
    };

    const postUpdateData = async () => {
        const formData = new FormData();
        formData.append('slug', id);
        setLoadings(true);
        try {
            const res = await postIncidentViewDetail(formData);
            setDetails(res.data.data);
            setLoadings(false);
        } catch (error) {
            toast.error(error?.response?.data?.message);
            console.log(error?.response?.data?.data);
        } finally {
            setLoadings(false);
        }
    };

    useEffect(() => {
        getCategoriesLists();
        getProfiles();
        getDepartmentLists();
        getAircarftTypes();
        getAirLineOperator();
        getAirportMasters();
        getAircraftRegistrationMasters();

        const formData = new FormData();
        formData.append('slug', id);
        postIncidentViewDetails(formData);
    }, [id]);

    useEffect(() => {
        const rawSubCategories = details?.what_occurred?.sub_category_id;
        if (rawSubCategories) {
            try {
                const parsed = JSON.parse(rawSubCategories); // e.g., { "1": [2, 3, 5] }

                const formatted = Object.entries(parsed).reduce((acc, [key, value]) => {
                    acc[parseInt(key)] = value;
                    return acc;
                }, {});

                setSelectedCheckboxes(formatted);

                // Set parent checkboxes as true
                const parentStates = Object.keys(formatted).reduce((acc, key) => {
                    acc[parseInt(key)] = true;
                    return acc;
                }, {});
                setselectedChkParent(parentStates);

                // console.log("Selected Subcategories:", formatted);
                // console.log("Selected Parents:", parentStates);
            } catch (err) {
                console.error("Failed to parse sub_category_id:", err);
            }
        }
    }, [details]);

    const handleCheckboxChange = (categoryId, subCategoryId, isChecked) => {
        setSelectedCheckboxes(prev => {
            const current = prev[categoryId] || [];
            let updated = [];

            if (isChecked) {
                updated = [...current, subCategoryId];
            } else {
                updated = current.filter(id => id !== subCategoryId);
            }

            const newState = { ...prev };
            if (updated.length > 0) {
                newState[categoryId] = updated;
            } else {
                delete newState[categoryId];
            }

            setselectedChkParent(parentPrev => {
                const parentState = { ...parentPrev };
                if (updated.length > 0) {
                    parentState[categoryId] = true;
                } else {
                    delete parentState[categoryId];
                }
                //console.log('parentState', parentState)
                return parentState;
            });
            //console.log('selectedCheckboxes', selectedCheckboxes)
            return newState;
        });
    };

    const initialValues = {
        caseType: details?.case_type,
        incidentClassification: details?.incident_classification,
        What: '',
        standardsReferenced: '',
        lessonsLearned: '',
        realLifeParallelExample: '',
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: '',
        onSubmit: async (values) => {

        },
    });
    const { values, handleChange, handleBlur, setFieldValue } = formik;

    useEffect(() => {
        setFieldValue('caseType', details?.case_type);
        setFieldValue('incidentClassification', details?.incident_classification);

        let standardsReferenceds = [];
        try {
            standardsReferenceds = JSON.parse(details?.safety_standards_referenced || '[]');
            if (!Array.isArray(standardsReferenceds)) standardsReferenceds = [];
        } catch (e) {
            standardsReferenceds = [];
        }
        const htmlList = `<ul>${standardsReferenceds.map(item => `<li>${item}</li>`).join('')}</ul>`;
        setFieldValue('standardsReferenced', htmlList);


    }, [details, setFieldValue]);

    const isMobileOrTablet = () => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        return /android|ipad|iphone|ipod/i.test(userAgent.toLowerCase());
    };

    const initialReport = (PDFUrl, Slug, Classification, CaseType, Time, DateStr) => {
        const [day, month, year] = DateStr.split('/');
        const dateObj = new Date(`${year}-${month}-${day}`);
        const dayPart = dateObj.getDate().toString().padStart(2, '0');
        const monthPart = dateObj.toLocaleString('en-US', { month: 'short' }).toUpperCase(); // "JUL"
        const yearPart = dateObj.getFullYear();

        const formattedDate = `${dayPart} ${monthPart} ${yearPart}`;

        const monthNum = (dateObj.getMonth() + 1).toString().padStart(2, '0'); // Add this
        const rname = `${year}${monthNum}${dayPart}`;
        const newrep = Slug.replace(rname, '');
        const finalRep = newrep.replace(/^[A-Z]{3}/, '');

        if (isMobileOrTablet()) {
            const link = document.createElement('a');
            link.href = PDFUrl;
            link.download = `1st_Initial_${Classification}_Related_${CaseType}_Report_at_${Slug}_${formattedDate}_${Time}.pdf`;
            document.body.appendChild(link);
            link.click();
            link.remove();
        } else {
            window.open(PDFUrl, '_blank');
        }
    };

    const formRef = useRef();

    const handleExternalSubmit = () => {
        if (formRef.current) {
            formRef.current.submitForm();
        }
    };


    const handlechangeRdo = async () => {
        setFieldValue("caseType", pendingValue);
        setShow(false);
        setLoadings(true);

        const formData = new FormData();
        formData.append('header_id', details?.header_id);
        formData.append('case_type', pendingValue);
        try {
            const res = await postUpdateCaseType(formData);
            console.log('res', res.data);
            toast.success(res.data.message);
            postUpdateData();

        } catch (error) {
            toast.error(error?.response?.data?.message || 'Something went wrong');
        } finally {
            setLoadings(false);
        }

    };
    return (
        <>
            <Header />

            <ToastContainer
                position="top-right"
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ zIndex: 9999999999, position: 'fixed' }}
            />

            <section id="forms">
                <div className="forms-block">
                    {isLoading ? <Loader /> :
                        <Container>
                            {isError ? (
                                <div className='nodata'>
                                    <h2>{msg}</h2>
                                    <div className='buttonbox'>
                                        <Link className='btn btn-green' to={'/home'}>Back to Home</Link>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <div className='flotingbuttion'>
                                        <button onClick={() => initialReport(details?.pdf_path, details?.report_number, details?.incident_classification, details?.case_type, details?.incident_time, details?.incident_date, details?.airport_codee)} className='btn btn-orange'>Initial Report</button>
                                    </div>

                                    <div className="form-box">
                                        <div className="fieldset" style={{ opacity: 0.7 }}>
                                            <h1>Where did it take place</h1>
                                            <div className="formsBox">
                                                <Row>
                                                    <Col md={4}>
                                                        <div className="form-group">
                                                            <label>Report Number</label>
                                                            <input type="text"
                                                                id="reportNumber"
                                                                name="reportNumber"
                                                                className="form-control"
                                                                autoComplete='off'
                                                                value={details?.report_number || ''}
                                                                readOnly={true}
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col md={4}>
                                                        <div className="form-group">
                                                            <label>Airport Name</label>
                                                            <input type="text"
                                                                id="airportName"
                                                                name="airportName"
                                                                className="form-control"
                                                                autoComplete='off'
                                                                value={details?.airport_name || ''}
                                                                readOnly={true}
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col md={4}>
                                                        <div className="form-group">
                                                            <label>ICAO Code</label>
                                                            <input type="text"
                                                                id="airportCode"
                                                                name="airportCode"
                                                                className="form-control"
                                                                autoComplete='off'
                                                                value={details?.airport_code || ''}
                                                                readOnly={true}
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col md={4}>
                                                        <div className="form-group io">
                                                            <label>Location</label>
                                                            <input type="text"
                                                                id="subExactCoordinates"
                                                                name="subExactCoordinates"
                                                                className="form-control"
                                                                autoComplete='off'
                                                                value={details.incident_lat != null && details.incident_lng != null
                                                                    ? `${details.incident_lat}, ${details.incident_lng}`
                                                                    : ''}
                                                                readOnly={true}
                                                            />
                                                            <Link to={details?.MapUrl} target='_blank'><img src={maps} alt='Map' title='Map' /></Link>
                                                        </div>
                                                    </Col>
                                                    <Col md={4}>
                                                        <div className="form-group">
                                                            <label>Exact Location</label>
                                                            <input type="text"
                                                                id="subIncidentArea"
                                                                name="subIncidentArea"
                                                                className="form-control"
                                                                autoComplete='off'
                                                                value={details?.incident_area || ''}
                                                                readOnly={true}
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col md={4}>
                                                        <div className="form-group">
                                                            <label>Is Incident Location a Known Hotspot?</label>
                                                            <select
                                                                id="incidentLocationHotspot"
                                                                name="incidentLocationHotspot"
                                                                className="form-control"
                                                                autoComplete="off"
                                                                value={details?.incident_location_hotspot?.toLowerCase() || 'no'}
                                                                disabled={true}
                                                            >
                                                                <option value="no">No</option>
                                                                <option value="yes">Yes</option>

                                                            </select>
                                                        </div>
                                                    </Col>
                                                    {details?.incident_location_hotspot === 'Yes' && (
                                                        <>
                                                            <Col md={4}>
                                                                <div className="form-group io">
                                                                    <label>Hotspot Zone Identifier (Code/Area)</label>
                                                                    <input type="text"
                                                                        id="hotspotZone"
                                                                        name="hotspotZone"
                                                                        className="form-control"
                                                                        autoComplete='off'
                                                                        value={details?.hotspot_zone || ''}
                                                                        readOnly={true}
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col md={4}>
                                                                <div className="form-group io">
                                                                    <label>Provide Previous Incident References or Frequency</label>
                                                                    <input type="text"
                                                                        id="previousIncidentReference"
                                                                        name="previousIncidentReference"
                                                                        className="form-control"
                                                                        autoComplete='off'
                                                                        value={details?.previous_incident_reference || ''}
                                                                        readOnly={true}
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </>
                                                    )}
                                                </Row>
                                            </div>
                                        </div>
                                        <div className="fieldset" style={{ opacity: 0.7 }}>
                                            <h1>When did it happen</h1>
                                            <div className="formsBox">
                                                <Row>
                                                    <Col md={3}>
                                                        <div className="form-group">
                                                            <label>Local Date (DD/MM/YYYY)</label>
                                                            <input type="date"
                                                                id="incidentDate"
                                                                name="incidentDate"
                                                                className="form-control"
                                                                autoComplete='off'
                                                                value={details?.incident_date || ''}
                                                                readOnly={true}
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col md={3}>
                                                        <div className="form-group">
                                                            <label>Local Time</label>
                                                            <input type="time"
                                                                id="localtime"
                                                                name="localtime"
                                                                className="form-control"
                                                                autoComplete='off'
                                                                value={details?.incident_time || ''}
                                                                readOnly={true}
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col md={3}>
                                                        <div className="form-group">
                                                            <label>UTC Date (DD/MM/YYYY)</label>
                                                            <input type="date"
                                                                id="utcdate"
                                                                name="utcdate"
                                                                className="form-control"
                                                                autoComplete='off'
                                                                value={details?.utc_date || ''}
                                                                readOnly={true}
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col md={3}>
                                                        <div className="form-group">
                                                            <label>UTC Time</label>
                                                            <input type="time"
                                                                id="utctime"
                                                                name="utctime"
                                                                className="form-control"
                                                                autoComplete='off'
                                                                value={details?.utc_time || ''}
                                                                readOnly={true}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='GroupList fieldset'>
                                        <div className="toggle-button">
                                            <h2 className="listTitle">What Occurred</h2>
                                            <div className='btnColaps'><FaChevronUp /></div>
                                        </div>
                                        <div className="formsBox subFilds">
                                            <Row className='resRow'>
                                                <Col md={4}>
                                                    <div className="form-group">
                                                        <label>Case Type</label>
                                                        <div className="radiogroups">
                                                            {["Incident", "Accident"].map(
                                                                (option) => (
                                                                    <div className="radiobox" key={option}>
                                                                        <label>
                                                                            {option}
                                                                            <input
                                                                                type="radio"
                                                                                name="caseType"
                                                                                value={option}
                                                                                checked={values.caseType === option}
                                                                                onChange={() => {
                                                                                    setPendingValue(option);
                                                                                    setShow(true);
                                                                                }}
                                                                                onBlur={handleBlur}
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                )
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="form-group">
                                                        <div className="radiogroups">
                                                            {["Aviation Safety Event", "HSSE Event"].map(
                                                                (option) => (
                                                                    <div className="radiobox" key={option}>
                                                                        <label>
                                                                            {option}
                                                                            <input
                                                                                type="radio"
                                                                                name="incidentClassification"
                                                                                value={option}
                                                                                checked={values.incidentClassification === option}
                                                                                disabled={true}
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                )
                                                            )}
                                                        </div>
                                                    </div>
                                                </Col>
                                                {details?.What == 'undefined' || details?.What == '' ? null : (
                                                    <Col md={8} className='rd-100'>
                                                        <div className="form-box">
                                                            <div className="fieldset intl">
                                                                <h1>Initial What Occurred</h1>
                                                                <div className="formsBox">
                                                                    <div className="form-group">
                                                                        <div dangerouslySetInnerHTML={{ __html: details?.What }}></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                )}
                                            </Row>
                                            <div id={values.incidentClassification == 'HSSE Event' ? 'hsseList' : 'aviationList'} className='formslistsData'>
                                                {categoriesList.map((item) => (
                                                    <div className={item.id === 1 ? 'checklists' : 'checklists grid'} key={item.id}
                                                        style={item.event_type === values.incidentClassification ? { display: 'block' } : { display: 'none' }}
                                                    >
                                                        <h4>{item.category_name}</h4>
                                                        <div className={item.id === 1 ? 'mainTypeList chkgroup' : 'chkgroup'}>
                                                            {item.incidentsubcategory.map((sublist) => {
                                                                const isChecked = selectedCheckboxes[item.id]?.includes(sublist.id) || false;
                                                                return (
                                                                    <div className="chekbox" key={sublist.id}>
                                                                        <label>
                                                                            {sublist.sub_category_name}
                                                                            <input
                                                                                type="checkbox"
                                                                                value={sublist.id}
                                                                                checked={isChecked}
                                                                                onChange={(e) =>
                                                                                    handleCheckboxChange(item.id, sublist.id, e.target.checked)
                                                                                }
                                                                            />
                                                                            <span className="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                            {selectedChkParent[1] && (
                                                <AircraftRelated details={details} selectedCheckboxes={selectedCheckboxes} postUpdateData={postUpdateData} aircraftTypes={aircraftTypes} airlineOperators={airlineOperators} airport={airport} aircraftRegistration={aircraftRegistration} toast={toast} />
                                            )}
                                            {selectedChkParent[2] && (
                                                <VehicleRelated details={details} selectedCheckboxes={selectedCheckboxes} postUpdateData={postUpdateData} aircraftTypes={aircraftTypes} airlineOperators={airlineOperators} airport={airport} aircraftRegistration={aircraftRegistration} toast={toast} />
                                            )}
                                            {selectedChkParent[3] && (
                                                <HealthRelated details={details} selectedCheckboxes={selectedCheckboxes} postUpdateData={postUpdateData} toast={toast} />
                                            )}
                                            {selectedChkParent[4] && (
                                                <AepResponse details={details} selectedCheckboxes={selectedCheckboxes} postUpdateData={postUpdateData} toast={toast} />
                                            )}
                                            {selectedChkParent[5] && (
                                                <JetBlastRelated details={details} selectedCheckboxes={selectedCheckboxes} postUpdateData={postUpdateData} aircraftTypes={aircraftTypes} airlineOperators={airlineOperators} airport={airport} aircraftRegistration={aircraftRegistration} toast={toast} />
                                            )}
                                            {selectedChkParent[6] && (
                                                <FireExplosionRelated details={details} selectedCheckboxes={selectedCheckboxes} postUpdateData={postUpdateData} toast={toast} />
                                            )}
                                            {selectedChkParent[7] && (
                                                <RunwayRelated details={details} selectedCheckboxes={selectedCheckboxes} postUpdateData={postUpdateData} toast={toast} />
                                            )}
                                            {selectedChkParent[8] && (
                                                <BuildingInfrastructureRelated details={details} selectedCheckboxes={selectedCheckboxes} postUpdateData={postUpdateData} toast={toast} />
                                            )}

                                            {/* HSSE */}
                                            {selectedChkParent[9] && (
                                                <PassengerTerminalIncident details={details} selectedCheckboxes={selectedCheckboxes} postUpdateData={postUpdateData} toast={toast} />
                                            )}

                                            {selectedChkParent[10] && (
                                                <CarParkCurbsideIncident details={details} selectedCheckboxes={selectedCheckboxes} postUpdateData={postUpdateData} toast={toast} />
                                            )}

                                            {selectedChkParent[11] && (
                                                <BuildingEnvironmental details={details} selectedCheckboxes={selectedCheckboxes} postUpdateData={postUpdateData} toast={toast} />
                                            )}

                                            {selectedChkParent[12] && (
                                                <HSSEOthers details={details} selectedCheckboxes={selectedCheckboxes} postUpdateData={postUpdateData} toast={toast} />
                                            )}
                                        </div>
                                    </div>

                                    <DescriptionFrm details={details} toast={toast} />
                                    <WhyDidItHappen details={details} postUpdateData={postUpdateData} toast={toast} />
                                    <WhoWasInvolvedForms details={details} postUpdateData={postUpdateData} toast={toast} />
                                    <StatementForms details={details} postUpdateData={postUpdateData} toast={toast} />
                                    <ActionTakenByDepartment ref={formRef} data={data} details={details} department={department} postUpdateData={postUpdateData} aircraftTypes={aircraftTypes} aircraftRegistration={aircraftRegistration} toast={toast} />

                                    {Array.isArray(details?.risk_matrix) && details.risk_matrix.length > 0 ? (
                                        <RiskMatrix details={details} postUpdateData={postUpdateData} toast={toast} />
                                    ) : null}
                                    {Array.isArray(details?.corrective_action_plan) && details.corrective_action_plan.length > 0 ? (
                                        <RecommendationActionPlan details={details} toast={toast} />
                                    ) : null}

                                    <PreventingActionPlan details={details} postUpdateData={postUpdateData} toast={toast} />
                                    <VerificationMonitoring details={details} postUpdateData={postUpdateData} toast={toast} />


                                    {details?.safety_standards_referenced == 'undefined' || details?.safety_standards_referenced == '' ? null : (
                                        <div className="form-box">
                                            <div className="fieldset intl">
                                                <h1>Initial Standards Referenced</h1>
                                                <div className="formsBox">
                                                    <div className="form-group">
                                                        <div dangerouslySetInnerHTML={{ __html: values.standardsReferenced }}></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {details?.LessonsLearned == 'undefined' || details?.LessonsLearned == '' ? null : (
                                        <div className="form-box">
                                            <div className="fieldset intl">
                                                <h1>Initial Lessons Learned</h1>
                                                <div className="formsBox">
                                                    <div className="form-group">
                                                        <div dangerouslySetInnerHTML={{ __html: details?.LessonsLearned }}></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {details?.RealLifeParallelExample == 'undefined' || details?.RealLifeParallelExample == '' ? null : (
                                        <div className="form-box">
                                            <div className="fieldset intl">
                                                <h1>Initial Real-Life Parallel Example</h1>
                                                <div className="formsBox">
                                                    <div className="form-group">
                                                        <div dangerouslySetInnerHTML={{ __html: details?.RealLifeParallelExample }}></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {data?.departmentname === 'HSSE' ?
                                        <div className="button-boxs grid">
                                            <button type='button' onClick={handleExternalSubmit} className='btn btn-red'>Submit Final Report & Close Case</button>
                                        </div>
                                        :
                                        <div className="button-boxs grid">
                                            <Link to={'/home'} className='btn btn-red'>Close</Link>
                                        </div>
                                    }


                                </>)}
                        </Container>
                    }
                </div>
            </section>

            {isShow ? (<>
                <Alert variant="danger" onClose={() => setShow(false)} dismissible>
                    <Alert.Heading>Are you sure you want to change Case Type?</Alert.Heading>
                    <hr />
                    <div className='buttons'>
                        <div>
                            <button onClick={() => handlechangeRdo()} className='btn btn-green'>OK</button>
                        </div>
                        <div>
                            <button onClick={() => setShow(false)} className='btn btn-red'>Cancel</button>
                        </div>
                    </div>
                </Alert>
                <div className='overly'></div>
            </>) : null}

            {isLoadings ? <Loader /> : null}
        </>
    );
}

export default Case;

